(ns ycweb.app.pos.admin.labels.location
  (:require
   [rum.core :as rum]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.util.core :as yuc]
   [ycweb.components.forms :as forms]
   [ycweb.components.wrapper :as w]
   [ycweb.components.transitions :as t]
   [ycweb.components.common :as cmn]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.app.pos.admin.common :as labels.cmn]))

(def printing-steps
  (forms/setup-steps
    [{:key :scan-printer :title "Fill in label/location details"}
     {:key :done :title "Done"}]))

(defn location-label-modal [app-atom]
  (labels.cmn/label-menu-modal app-atom [:store-admin] :printer-barcode))

;; ================== Print Location Label Screen ===========================

(rum/defc print-location-labels < rum/reactive [app-atom]
  (let [blitz? (cmn/curact app-atom :blitz?)
        process-atom (cmn/process-cursor app-atom)
        location-label-atom (rum/cursor process-atom :location-label-config)
        {:keys [printer-barcode qty barcodes label-type basket-colour bin-type]} (rum/react location-label-atom)

        print-label-type-allowed?
        (cond
          (= "trolley" label-type)
          true

          (= "basket" label-type)
          (yuc/presence basket-colour)

          (= "bin" label-type)
          (yuc/presence bin-type)

          :else
          (yuc/presence barcodes))]

    (w/wrapper app-atom (str (if blitz? "Warehouse" "Store") " Admin") {:steps printing-steps :step :scan-printer :modal-fn location-label-modal}
      [[:div
        {:class (yuc/bem :section [:medium])}
        [:h2.u-text-center
         {:class (yuc/bem :heading [:standard])}
         "Print Custom Labels"]

        (forms/textarea "Labels"
          (rum/cursor location-label-atom :barcodes)
          {:required? true
           :hint "Type locations (W-X-Y-Z format) or barcodes, one per line"
           :rows 10})

        (forms/select "Parent Location"
          (rum/cursor location-label-atom :parent-location-type)
          [{:text "Default" :value :default}
           {:text "Picking" :value :picking}
           {:text "Collection" :value :collection}
           {:text "Bulk" :value :bulk}
           {:text "Packing" :value :packing}
           {:text "Trolley" :value :trolley}
           {:text "Picked" :value :picked}
           {:text "Shop" :value :shop}
           {:text "Receiving" :value :receiving}]
          {:type :keyword
           :default :default})

        [:div.form-field
         (forms/checkbox
           "Force new locations"
           (rum/cursor location-label-atom :new-locations?)
           {})]

        [:div.form-field
         (forms/checkbox
           "Force custom locations"
           (rum/cursor location-label-atom :custom-locations?)
           {})]

        (forms/select "Label Type"
          (rum/cursor location-label-atom :label-type)
          [{:text "Locations" :value "locations"}
           {:text "Text only" :value "textonly"}
           {:text "Trolleys" :value "trolley"}
           {:text "Baskets" :value "basket"}
           {:text "Bins" :value "bin"}]
          {:default "locations"})

        (forms/input "Colour:" "Basket colour (eg. S, B)"
          (rum/cursor-in location-label-atom [:basket-colour])
          {:required? true
           :type :text
           :disabled (when-not (= "basket" label-type) true)
           :icon? true})

        (forms/input "Type:" "Bin type (eg. K, G)"
          (rum/cursor-in location-label-atom [:bin-type])
          {:required? true
           :type :text
           :disabled (when-not (= "bins" label-type) true)
           :icon? true})

        (forms/input "Quantity" "number of labels"
          (rum/cursor-in location-label-atom [:qty])
          {:required? true
           :type :number
           :icon? true})

        (forms/input "Printer:" "Type in or scan the printer code (frequently used: R-4-A-1-P or R-4-B-1-P)"
          (rum/cursor-in location-label-atom [:printer-barcode])
          {:required? true
           :type :barcode
           :icon? true})]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Print"
         :right-fn
         (when
           (and
             print-label-type-allowed?
             (yuc/presence printer-barcode)
             (pos? qty))
           #(grid/dispatch-action app-atom :store-admin/print-location-labels {:scan printer-barcode}))}))))

(defmethod flow/render-screen :store-admin/location-labels [app-atom]
  (print-location-labels app-atom))

(defmethod flow/barcode-dispatch-screen :store-admin/location-labels [_ app-atom scan]
  (grid/dispatch-action app-atom :store-admin/print-location-labels {:scan scan}))

(defmethod grid/action :store-admin/print-location-labels [app-atom {:keys [scan]}]
  (let [process-atom (cmn/process-cursor app-atom)
        location-label-cfg (cmn/curact process-atom :location-label-config)]
    (toaster/open-subtle-progress app-atom)
    (comms/send :pos.printers/print-location-labels (assoc location-label-cfg :printer-barcode scan))))

(defmethod comms/receive :pos.printers/print-location-labels [app-atom e]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :store-admin/location-labels-done))

;; ================== Done Screen ===========================

(defmethod flow/render-screen :store-admin/location-labels-done [app-atom]
  (labels.cmn/labels-done app-atom printing-steps))